// import { gql } from '@apollo/client';
import gql from 'graphql-tag';


export const ALL_USERS_QUERY = gql`
query AllUsers($lastName: [String!], $email: [String!], $username: [String!], $isStaff: Boolean, $isActive: Boolean , $firstName: [String!], $after: String, $first: Int) {
  usersConnectionFiltered(
    filters: {lastName: {inList: $lastName}, email: {inList: $email}, username: {inList: $username}, isStaff: $isStaff, isActive: $isActive, firstName: {inList: $firstName}}
    after: $after
    first: $first
  ) {
    edges {
      node {
        email
        username
        firstName
        lastName
        orgDetails {
          id
          email
          jobFunction
          market
          segment
          persona {
            name
          }
        }
        isStaff
        isActive
        dateJoined
        id
        lastLogin
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
`;

export const USER_ALL_DETAILS_QUERY = gql`
query UserAllDetails($id: GlobalID!) {
  user(id: $id) {
    id
    email
    firstName
    isStaff
    isActive
    dateJoined
    orgDetails {
      id
      segment
      market
      jobFunction
      email
      persona {
        id
        name
      }
    }
    favourites {
      report {
        title
        yearCreated
      }
      creationTime
      id
    }
    lastLogin
    lastName
    username
    recentViews {
      report {
        title
        id
        visitCount
      }
      visitTime
    }
    notifications {
      notification
    }
  }
}
`;




// export const USER_PREFERENCES_QUERY = gql`
// query UserPreferencesQuery {
//   preferences {
//     id
//     sidebar
//     layout {
//       name
//     }
//     theme {
//       name
//     }
//   }
// }
// `;




// export const UPDATE_SIDEBAR_MUTATION = gql`
// mutation UpdateSidebar($id: GlobalID!, $sidebar: Boolean!) {
//   updatePreferences(
//     input: {id: $id, sidebar: $sidebar}
//   ) {
//     ... on PreferenceType {
//       id
//       sidebar
//     }
//   }
// }
// `;

// export const UPDATE_LAYOUT_MUTATION = gql`
// mutation UpdateLayout($id: GlobalID!, $layout_id: GlobalID!) {
//   updatePreferences(input: {id: $id, layout: {id: $layout_id}}) {
//     ... on PreferenceType {
//       id
//       layout {
//         name
//       }
//     }
//   }
// }
// `;

// export const UPDATE_THEME_MUTATION = gql`
// mutation UpdateTheme($id: GlobalID!, $theme_id: GlobalID!) {
//   updatePreferences(input: {id: $id, theme: {id: $theme_id}}) {
//     ... on PreferenceType {
//       id
//       theme {
//         name
//       }
//     }
//   }
// }
// `;

// export const ADD_FAVOURITE_MUTATION = gql`
// mutation AddFavourite($userID: GlobalID!, $reportID: GlobalID!) {
//   addFavourite(input: {user: {id: $userID}, report: {id: $reportID}}) {
//     ... on FavouriteType {
//       id
//     }
//   }
// }
// `;

// export const REMOVE_FAVOURITE_MUTATION = gql`
// mutation RemoveFavourite($favouriteID: GlobalID!) {
//   removeFavourite(input: {id: $favouriteID}) {
//     ... on FavouriteType {
//       id
//     }
//   }
// }
// `;

// export const ADD_RECENT_MUTATION = gql`
// mutation AddRecent($userID: GlobalID!, $reportID: GlobalID! ) {
//   addRecent(input: {user: {id: $userID}, report: {id: $reportID}, }) {
//     ... on RecentViewsType {
//       id
//     }
//   }
// }
// `;

// export const REMOVE_RECENT_MUTATION = gql`
// mutation RemoveRecent($recentViewID: GlobalID!) {
//   removeRecent(input: {id: $recentViewID}) {
//     ... on RecentViewsType {
//       id
//     }
//   }
// }
// `;


// export const USER_NOTIFICATION_QUERY = gql`
// query GetAllUserNotifications($isSeen: Boolean = false) {
//   me {
//     id
//     notifications(filters: {isSeen: $isSeen}) {
//       id
//       notification
//       isSeen
//     }
//   }
// }
// `;

// export const USER_NOTIFICATION_SUBSCRIPTION = gql`
// subscription SubscribeToUserNotifications {
//   allNotificationsChannel {
//     id
//     notification
//     isSeen
//   }
// }
// `;


// TODO: #26 Implement graphql channels based notification
//Sample mutation queries
// mutation MessageToSachin {
//   sendNotificationMessage(
//     message: "kya baat hai veere "
//     user: { email: "sachin.mahajan1@effem.com"}
//   )
// }

// mutation MessageToAdmin {
//   sendNotificationMessage(
//     message: "hello admin ji fir se  "
//     user: { email: "admin@mysupplychain.azurewebsites.net"}
//   )
// }